const faqs = {
  init: function () {
    faqs.accordion();
  },
  accordion: function () {
    var header_class = ".faq__header";
    var faq_active = "faq-open";
    $("body").on("click", header_class, function () {
      var btn = $(this);
      var faq = btn.closest(".faq");
      var siblings = faq.siblings();

      // Show content
      faq.children(".faq__body").slideToggle(250);

      // Close siblings
      siblings.removeClass(faq_active);
      siblings.children(".faq__body").slideUp(250);

      // Scroll to dropdown
      if (!faq.hasClass(faq_active)) {
        setTimeout(function () {
          var scrollTo = faq.offset().top - $(".main").offset().top;
          $("html, body").animate(
            {
              scrollTop: scrollTo - 40,
            },
            250
          );
        }, 250);
      }

      // Animate header
      faq.toggleClass(faq_active);
    });
  },
};
export default faqs;
